export default __webpack_public_path__ + "static/media/manjesh.3c53d0a0.jpg";